import React, { useState } from 'react';
import styled from './index.module.scss';
//import { EFEmail } from '@/components/UI/svg/Footer';
import EFEmail from '@/components/UI/svg/Footer/Icon/EFEmail';
import { useGlobal } from '@/utils/useGlobal';
import { subscribe, subscribeShopify, subscribeMultiEmarsysEmail } from '@/service/membersday';
import { message } from '@/components/UI/Message';
import { i18nText } from '@/app/eflayout/Footer/i18nText';
import { CookieDataExtendType } from 'eco-design-reliance/cookies/type';

interface fieldsType {
    id: string;
    type: string;
    value: number | number[];
    overwrite: boolean;
}

interface IEmarsysProps {
    defaultValue?: string;
    showEamilIcon?: boolean;
    submitText: string;
    placeholder: string;
    source?: string;
    data?: any;
    hideTips?: boolean;
    checked?: boolean;
    disabled?: boolean;
    successCallback?: any;
    errorCallback?: () => void;
    contactListId: string | string[];
    fields?: fieldsType[];
    subscribeData?: CookieDataExtendType;
}

const reg = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
const Emarsys: React.FC<IEmarsysProps> = ({
    defaultValue = '',
    showEamilIcon = false,
    submitText,
    placeholder,
    source,
    data,
    hideTips = false,
    checked = true,
    disabled = false,
    successCallback,
    errorCallback,
    contactListId,
    fields,
    subscribeData,
}) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared');
    const [inputValue, setInputValue] = useState(defaultValue || '');
    const [loading, setLoading] = useState(false);
    // const isDisabled = !reg.test(inputValue) || disabled;
    const [failTips, setFailTips] = useState('');
    const textA = i18nText[locale] || i18nText['en'];

    const handleSubmit = async () => {
        // 必须有传值
        if (!contactListId) {
            return null;
        }
        if (!inputValue) {
            return setFailTips('fail-1');
        }
        if (!reg.test(inputValue)) {
            return setFailTips('fail-2');
        }
        if (!checked) {
            return setFailTips('fail-4');
        }
        if (loading) {
            return;
        }
        setLoading(true);
        if (source) {
            subscribeMultiEmarsysEmail(
                locale,
                {
                    contactListId,
                    email: inputValue,
                    fields,
                    source,
                },
                {
                    sector_name: submitText,
                    entry_position: 4,
                },
            )
                .then((res) => {
                    setLoading(false);
                    if (res.code !== '0') {
                        errorCallback && errorCallback();
                        return message.error(res.message);
                    }

                    setInputValue('');
                    setFailTips('success');
                    setTimeout(() => {
                        successCallback && successCallback(inputValue);
                    }, 1000);
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                    errorCallback && errorCallback();
                });
            // subscribe(inputValue, locale, source)
            //     .then((res) => {
            //         setLoading(false);
            //         if (res.code !== '0') {
            //             errorCallback && errorCallback();
            //             return message.error(res.message);
            //         }

            //         setInputValue('');
            //         setFailTips('success');
            //         setTimeout(() => {
            //             successCallback && successCallback(inputValue);
            //         }, 1000);
            //     })
            //     .catch((err) => {
            //         setLoading(false);
            //         console.log(err);
            //         errorCallback && errorCallback();
            //     });
        } else {
            if (!data.fields[data.fields.length - 1].value || data.fields[data.fields.length - 1].value.length === 0) {
                setFailTips('fail-3');
                setLoading(false);
                return;
            }
            subscribeShopify(
                Object.assign(data, {
                    email: inputValue,
                }),
                locale,
                subscribeData,
            )
                .then((res) => {
                    setLoading(false);
                    if (res.code !== '0' && res.code !== '2058') {
                        errorCallback && errorCallback();
                        return message.error(res.message);
                    }

                    setInputValue('');
                    setFailTips('success');
                    successCallback && successCallback(inputValue);
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err);
                    errorCallback && errorCallback();
                });
        }
    };

    return (
        <div className={`${styled.emarsys_form} members-emarsys-form`}>
            <div className={`emarsys-in`}>
                <div className="emarsys-input">
                    {showEamilIcon && (
                        <span className="emarsys-icon">
                            <EFEmail />
                        </span>
                    )}
                    <input
                        type="text"
                        value={inputValue}
                        onInput={(e: any) => {
                            setInputValue(e.target.value.trim());
                            setFailTips('');
                        }}
                        placeholder={placeholder ?? t('site_bottom_subscription_email')}
                    />
                </div>
                <button type="submit" className="emarsys-submit" onClick={handleSubmit} disabled={disabled}>
                    {submitText}
                </button>
            </div>
            <div className="emarsys-tips">
                {failTips === 'fail-1' && <span className="emarsys-tips-fail">{textA.site_bottom_subscription_tip_two}</span>}
                {failTips === 'fail-2' && <span className="emarsys-tips-fail">{textA.site_bottom_subscription_tip_two}</span>}
                {failTips === 'fail-3' && <span className="emarsys-tips-fail">{textA.site_bottom_subscription_tip_five}</span>}
                {failTips === 'fail-4' && <span className="emarsys-tips-fail">{textA.site_bottom_subscription_email_protocol_hint}</span>}
                {failTips === 'success' && !hideTips && <span className="emarsys-tips-success">{textA.site_bottom_subscription_sms_phone_thank}</span>}
            </div>
        </div>
    );
};
export default Emarsys;
